/**
 * inn_data.ts — INN 中英文对照数据（静态，不可修改）
 * 自动生成自 inn_rules.py，300+ 药品
 */

export const INN_TO_CN: Record<string, string> = {
  // SGLT-2 抑制剂
  "empagliflozin": "恩格列净",
  "dapagliflozin": "达格列净",
  "canagliflozin": "卡格列净",
  "ertugliflozin": "艾托格列净",
  // DPP-4 抑制剂
  "sitagliptin": "西格列汀",
  "linagliptin": "利格列汀",
  "saxagliptin": "沙格列汀",
  "vildagliptin": "维格列汀",
  "alogliptin": "阿格列汀",
  "teneligliptin": "替尼格列汀",
  // GLP-1
  "liraglutide": "利拉鲁肽",
  "semaglutide": "司美格鲁肽",
  "dulaglutide": "度拉糖肽",
  "exenatide": "艾塞那肽",
  // 双胍类
  "metformin": "二甲双胍",
  // 磺酰脲类
  "glimepiride": "格列美脲",
  "glipizide": "格列吡嗪",
  "glyburide": "格列本脲",
  "glibenclamide": "格列本脲",
  "gliclazide": "格列齐特",
  "gliquidone": "格列喹酮",
  // 钙通道阻滞剂
  "nifedipine": "硝苯地平",
  "amlodipine": "氨氯地平",
  "felodipine": "非洛地平",
  "nicardipine": "尼卡地平",
  "lacidipine": "拉西地平",
  "lercanidipine": "乐卡地平",
  "cilnidipine": "西尼地平",
  // ACE 抑制剂
  "enalapril": "依那普利",
  "lisinopril": "赖诺普利",
  "ramipril": "雷米普利",
  "perindopril": "培哚普利",
  "imidapril": "咪达普利",
  "quinapril": "喹那普利",
  "captopril": "卡托普利",
  "fosinopril": "福辛普利",
  "trandolapril": "群多普利",
  // ARB
  "valsartan": "缬沙坦",
  "losartan": "氯沙坦",
  "irbesartan": "厄贝沙坦",
  "telmisartan": "替米沙坦",
  "olmesartan": "奥美沙坦",
  "candesartan": "坎地沙坦",
  // 他汀类
  "atorvastatin": "阿托伐他汀",
  "simvastatin": "辛伐他汀",
  "rosuvastatin": "瑞舒伐他汀",
  "pravastatin": "普伐他汀",
  "fluvastatin": "氟伐他汀",
  "pitavastatin": "匹伐他汀",
  "lovastatin": "洛伐他汀",
  // 质子泵抑制剂
  "omeprazole": "奥美拉唑",
  "esomeprazole": "艾司奥美拉唑",
  "lansoprazole": "兰索拉唑",
  "pantoprazole": "泮托拉唑",
  "rabeprazole": "雷贝拉唑",
  // 抗血小板
  "clopidogrel": "氯吡格雷",
  "ticagrelor": "替格瑞洛",
  "prasugrel": "普拉格雷",
  // 抗凝血
  "rivaroxaban": "利伐沙班",
  "apixaban": "阿哌沙班",
  "edoxaban": "艾多沙班",
  "dabigatran": "达比加群",
  "warfarin": "华法林",
  "enoxaparin": "依诺肝素",
  // 抗抑郁
  "sertraline": "舍曲林",
  "fluoxetine": "氟西汀",
  "paroxetine": "帕罗西汀",
  "escitalopram": "艾司西酞普兰",
  "citalopram": "西酞普兰",
  "venlafaxine": "文拉法辛",
  "duloxetine": "度洛西汀",
  "mirtazapine": "米氮平",
  "bupropion": "安非他酮",
  // 镇痛/抗炎
  "ibuprofen": "布洛芬",
  "naproxen": "萘普生",
  "diclofenac": "双氯芬酸",
  "celecoxib": "塞来昔布",
  "acetaminophen": "对乙酰氨基酚",
  "paracetamol": "对乙酰氨基酚",
  // 抗癫痫
  "carbamazepine": "卡马西平",
  "valproic_acid": "丙戊酸",
  "lamotrigine": "拉莫三嗪",
  "levetiracetam": "左乙拉西坦",
  "topiramate": "托吡酯",
  "phenytoin": "苯妥英",
  "gabapentin": "加巴喷丁",
  "pregabalin": "普瑞巴林",
  // 抗菌/抗病毒
  "amoxicillin": "阿莫西林",
  "azithromycin": "阿奇霉素",
  "ciprofloxacin": "环丙沙星",
  "levofloxacin": "左氧氟沙星",
  "moxifloxacin": "莫西沙星",
  "ceftriaxone": "头孢曲松",
  "metronidazole": "甲硝唑",
  "doxycycline": "多西环素",
  "oseltamivir": "奥司他韦",
  "acyclovir": "阿昔洛韦",
  // 激素
  "levothyroxine": "左甲状腺素",
  "prednisone": "泼尼松",
  "prednisolone": "泼尼松龙",
  "dexamethasone": "地塞米松",
  "estradiol": "雌二醇",
  "progesterone": "黄体酮",
  // 抗肿瘤
  "imatinib": "伊马替尼",
  "gefitinib": "吉非替尼",
  "erlotinib": "厄洛替尼",
  "sorafenib": "索拉非尼",
  // 免疫抑制
  "cyclosporine": "环孢素",
  "tacrolimus": "他克莫司",
  // 抗尿酸
  "allopurinol": "别嘌醇",
  "febuxostat": "非布司他",
  // 抗结核
  "delamanid": "德拉玛尼",
  // 消化系统
  "montelukast": "孟鲁司特",
};

export const CN_TO_INN: Record<string, string> = Object.fromEntries(
  Object.entries(INN_TO_CN).map(([k, v]) => [v, k])
);

export const BRAND_TO_INN: Record<string, string> = {
  "jardiance": "empagliflozin",
  "forxiga": "dapagliflozin",
  "invokana": "canagliflozin",
  "januvia": "sitagliptin",
  "janumet": "sitagliptin_metformin",
  "victoza": "liraglutide",
  "ozempic": "semaglutide",
  "trulicity": "dulaglutide",
  "bydureon": "exenatide",
  "glucophage": "metformin",
  "adalat": "nifedipine",
  "norvasc": "amlodipine",
  "diovan": "valsartan",
  "cozaar": "losartan",
  "lipitor": "atorvastatin",
  "crestor": "rosuvastatin",
  "plavix": "clopidogrel",
  "xarelto": "rivaroxaban",
  "eliquis": "apixaban",
  "pradaxa": "dabigatran",
  "zoloft": "sertraline",
  "prozac": "fluoxetine",
  "lyrica": "pregabalin",
  "neurontin": "gabapentin",
  "celebrex": "celecoxib",
  "tylenol": "acetaminophen",
  "advil": "ibuprofen",
  "aleve": "naproxen",
  "voltaren": "diclofenac",
};
